module.exports = __webpack_public_path__ + "img/o9.6d585dfa.png";